import { render, staticRenderFns } from "./openingHours.vue?vue&type=template&id=6d50139d&"
import script from "./openingHours.js?vue&type=script&lang=js&"
export * from "./openingHours.js?vue&type=script&lang=js&"
import style0 from "./openingHours.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d50139d')) {
      api.createRecord('6d50139d', component.options)
    } else {
      api.reload('6d50139d', component.options)
    }
    module.hot.accept("./openingHours.vue?vue&type=template&id=6d50139d&", function () {
      api.rerender('6d50139d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header/openingHours/openingHours.vue"
export default component.exports